import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a non-Enterprise admin sees the Audit Logs upsell state',
  name: 'audit_log_upsell_viewed',
  params: [
    {
      description: 'Workspace the upsell was shown for',
      name: 'workspace_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Display name of the workspace subscription plan',
      name: 'plan_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
